/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Heading_ItalicInputs */

const et_about_heading_italic = /** @type {(inputs: About_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suunatud väike-ettevõtjatele.`)
};

const en_about_heading_italic = /** @type {(inputs: About_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimized for profit.`)
};

/**
* | output |
* | --- |
* | "Optimized for profit." |
*
* @param {About_Heading_ItalicInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const about_heading_italic = /** @type {((inputs?: About_Heading_ItalicInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Heading_ItalicInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_about_heading_italic(inputs)
	return en_about_heading_italic(inputs)
});